import styled from 'styled-components';

export const HallmapContainer = styled.div`
	background: white;
`;
